/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Day_Names_TuesdayInputs */

const fr_week_session_day_names_tuesday = /** @type {(inputs: Week_Session_Day_Names_TuesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mar`)
};

/**

* @param {Week_Session_Day_Names_TuesdayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_day_names_tuesday = /** @type {((inputs?: Week_Session_Day_Names_TuesdayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Day_Names_TuesdayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_day_names_tuesday(inputs)
});